import { useCallback, useState, createContext, useMemo, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import A from './ActionCreators';

export const CropDragContext = createContext({});

export default function CropDragProvider({figurePanelId, children}){

  let dispatch = useDispatch();

  const mouseUpOccurredOnceAfterCropsSelected = useRef(false);

  const [ cropIdsBeingDragged, setCropIdsBeingDragged ] = useState([]);



  const onCropDrop = useCallback(cell => {


    dispatch(A.setCellsValue({
          figurePanelId,
          cells:[cell],
          value:cropIdsBeingDragged[0],
          /*{
            valueType:'crop',
            annotationId:cropIdsBeingDragged[0].annotationId
          }*/
        }))
        setCropIdsBeingDragged([]);

  },[cropIdsBeingDragged,dispatch,figurePanelId])


  const value = useMemo(() => ({ cropIdsBeingDragged, setCropIdsBeingDragged, onCropDrop }),[cropIdsBeingDragged,onCropDrop]);

  useEffect(() => {

    const onMouseUp = e => {

      if( mouseUpOccurredOnceAfterCropsSelected.current ){

        if( cropIdsBeingDragged && cropIdsBeingDragged.length > 0 ){

          //console.log("Mouse up and dragids ("+JSON.stringify(cropIdsBeingDragged)+") cleared.");
          setCropIdsBeingDragged([]);

        }

        mouseUpOccurredOnceAfterCropsSelected.current = false

      }else{
        mouseUpOccurredOnceAfterCropsSelected.current = true
      }
      
      
    }

    window.addEventListener('mouseup',onMouseUp)

    return () => {
      window.removeEventListener('mouseup',onMouseUp);
    }

  },[cropIdsBeingDragged,setCropIdsBeingDragged])

  

  return (
    <CropDragContext.Provider value={value}>
      <div style={{position:'fixed',
        top:0,
        right:0,
        background:'black',
        color:'cyan'}}>
      </div>
      {children}
    </CropDragContext.Provider>
  )
}
